export const ColorTokens = {
  primary: '#000',
  secondary: '#4A4A4A',
  tertiary: '#797979',
  quartenary: '#b8b8b8',
  quinary: '#d4d4d4',
  background: '#EAEAEA',
  title: '#1E1E1E',
};
